<div class="wrapper">
  <div id="cqChart" [ngClass]="{'special': (showPlaceholder$ | async)}" #cqChart></div>
  @if ((showPlaceholder$ | async)) {
    <div class="placeholder">
      <p>CQ graph</p>
      <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
    </div>
  }
</div>